import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnterprisePreferencesPolicyDto } from '../interfaces/enterprise-preferences-policy-dto';
import { EnterprisePolicyDto } from '../interfaces/enterprise-policy-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class EnterprisePreferencesPolicyService {
    private readonly http = inject(HttpClient);
    private env = inject(envToken);

    getEnterprisePreferencesPolicyUrl = '';
    setEnterprisePreferencesPolicyUrl = '';

    constructor() {
        this.getEnterprisePreferencesPolicyUrl = this.env.apiUrl + '/api/v1/enterprise-preferences-policy/enterprise/';
        this.setEnterprisePreferencesPolicyUrl = this.env.apiUrl + '/api/v1/policy/enterprise-preferences/enterprise/';
    }

    getEnterprisePreferencesPolicy(enterpriseId: number): Observable<EnterprisePreferencesPolicyDto> {
        return this.http.get<EnterprisePreferencesPolicyDto>(`${this.getEnterprisePreferencesPolicyUrl}${enterpriseId}`);
    }

    setEnterprisePreferencesPolicy(enterpriseId: number, enterprisePreferencesPolicy: EnterprisePreferencesPolicyDto): Observable<EnterprisePolicyDto> {
        return this.http.post<EnterprisePolicyDto>(`${this.setEnterprisePreferencesPolicyUrl}${enterpriseId}`, enterprisePreferencesPolicy);
    }
}
